import { PromoCreateDto, PromoUpdateDto, Pagination } from '@libs/dto';
import { Promo } from '@libs/models';

import { api } from '../common.api';

export const promoApi = api.injectEndpoints({
  endpoints: (build) => ({
    promoCreate: build.mutation<Promo, PromoCreateDto>({
      query: (body) => ({
        url: '/promo',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Promo'],
    }),
    promoUpdate: build.mutation<Promo, PromoUpdateDto>({
      query: (body) => ({
        url: `/promo/${body.id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Promo'],
    }),
    promoIndex: build.query<Pagination<Promo>, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: '/promo',
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Promo'],
    }),
    promoActive: build.query<Pagination<Promo>, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: '/promo/active',
        method: 'GET',
        params: { page, limit },
      }),
    }),
    promoSearch: build.query<Pagination<Promo>, { q: string; page?: number; limit?: number }>({
      query: ({ q, page = 1, limit = 10 }) => ({
        url: '/promo/search',
        method: 'GET',
        params: { q, page, limit },
      }),
      providesTags: ['Promo'],
    }),
    promoView: build.query<Promo, number>({
      query: (id) => ({
        url: `/promo/${id}`,
        method: 'GET',
      }),
      providesTags: ['Promo'],
    }),
    promoValidate: build.query<{ valid: boolean; promo?: Promo; message?: string }, string>({
      query: (code) => ({
        url: `/promo/validate/${code}`,
        method: 'GET',
      }),
      providesTags: ['Promo'],
    }),
    promoIncrementUses: build.mutation<Promo, number>({
      query: (id) => ({
        url: `/promo/increment/${id}`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Promo'],
    }),
    promoDelete: build.mutation<Promo, number>({
      query: (id) => ({
        url: `/promo/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Promo'],
    }),
    promoActivate: build.mutation<Promo, number>({
      query: (id) => ({
        url: `/promo/activate/${id}`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Promo'],
    }),
    promoDeactivate: build.mutation<Promo, number>({
      query: (id) => ({
        url: `/promo/deactivate/${id}`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Promo'],
    }),
  }),
});

export const {
  usePromoCreateMutation,
  usePromoUpdateMutation,
  usePromoIndexQuery,
  usePromoSearchQuery,
  usePromoViewQuery,
  usePromoValidateQuery,
  usePromoIncrementUsesMutation,
  usePromoDeleteMutation,
} = promoApi; 